// @ts-ignore
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { DatabaseJsonStore, CharacterManagementStore, store } from './store'

// @ts-ignore
import 'vuetify/dist/vuetify.min.css'
import Vuetify from 'vuetify'
import vuetify from './plugins/vuetify'
import { marked } from 'marked'
import { getModule } from 'vuex-module-decorators'
import Tooltip from '@/components/TooltipParam.vue'
import ShowGreenvaleCharts from '@/components/ShowGreenvaleCharts.vue'

Vue.config.productionTip = false
Vue.use(Vuetify)

Vue.component('Tooltip', Tooltip)
Vue.component('ShowGreenvaleCharts', ShowGreenvaleCharts)

Vue.prototype.$marked = marked
Vue.prototype.$jenna = require('@/assets/art/Jenna.png')
Vue.prototype.$stakes = require('@/assets/Stakes.png')
Vue.prototype.$general = require('@/assets/General.svg')
Vue.prototype.$strike = require('@/assets/Strike.svg')
Vue.prototype.$speed = require('@/assets/Move.svg')
Vue.prototype.$support = require('@/assets/Support.svg')
Vue.prototype.$defend = require('@/assets/Defend.svg')
Vue.prototype.$map = require('@/assets/MockMap.png')

router.afterEach((to, from) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.title || 'Shattered Spirits'
  })
})

import { GlossaryItem, Ability, AbilityPackage, Armor, Equipment, Weapon, Terrain, Status } from '@/class'
Vue.prototype.GlossaryItem = GlossaryItem
Vue.prototype.Ability = Ability
Vue.prototype.AbilityPackage = AbilityPackage
Vue.prototype.Armor = Armor
Vue.prototype.Weapon = Weapon
Vue.prototype.Equipment = Equipment
Vue.prototype.Terrain = Terrain
Vue.prototype.Status = Status

Vue.mixin({
  computed: {
    isMobile: function () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    prettyTab(tab) {
      var newTab = tab.replaceAll('-', ' ')
      newTab = newTab
        .split(' ')
        .map((word) => (word != 'and' && word != 'of' && word != 'the' ? word.charAt(0).toUpperCase() + word.slice(1) : word))
        .join(' ')
      return newTab.charAt(0).toUpperCase() + newTab.slice(1)
    },
    updateTab(newTab) {
      if (this.$route.params.tab != newTab) {
        this.$router.push({ params: { tab: newTab } })
      }
    },
    mobileOrNormal(category_name) {
      if (screen.width <= 760) {
        return category_name + '-mobile'
      }
      return category_name
    },
  },
})

new Vue({
  components: { App },
  router,
  store,
  vuetify,
  async created() {
    await getModule(DatabaseJsonStore, store).loadDatabase()
    await getModule(CharacterManagementStore, store).loadCharacters()
  },
  render: (h) => h(App),
}).$mount('#app')
